export enum MeetingDeclineReason {
    DeclinedByCustomer,
    DeclinedByOrganizer,
}
